import {useEffect} from 'react'

export default function FloatLabel({active, label, children, value = "", name = null, props}) {

  return (
    <div className="input-float-label-wrapper" style={{display: 'flex', flexFlow: 'column-reverse'}}>

      {children}

      <label className={`input-float-label ${active || value.length > 0 ? 'active' : ''}`}>
        {label}
      </label>
    </div>
  )
}